import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { EmployeeDetails } from '../employees-training-plan/models/employee-details';
import { SelectedUserScopesDTO } from '../employees-training-plan/models/selectedUserScopesDTO';
import { UserService } from '../user-profile/user.service';
import { UserProfile } from '../user-profile/models/user-profile';
import { UserProfileConstants } from '../user-profile/user-profile-constants';
import { EqmsScopeManagementService } from '../../../app/shared/services/eqms-scope-management.service';
import { TreeData } from '../../../app/shared/models/TreeData';
import { EmployeesDetailsDto } from '../user-profile/models/employeesDetailsDto';
import { UserProfileSliderComponent } from '../user-profile/user-profile-slider/user-profile-slider.component';
import { delay, Observable, of } from 'rxjs';
import { MySpaceConstants } from '../my-space-constants';
import { formatDate } from '@angular/common';
import { DefaultValueConstants } from '../../shared/constants/default-value-constants';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';

@Component({
  selector: 'app-my-employees-profile',
  templateUrl: './my-employees-profile.component.html',
  styleUrls: ['./my-employees-profile.component.scss']
})

export class MyEmployeesProfileComponent implements OnInit{
  ngOnInit(): void {
    this.loadUsersList();
  }

  valueField: string = 'puid';
  labelField: string = 'name';
  employeeDetails: EmployeeDetails[] = [];
  selectedPuid: string | null = null;
  myEmployeesTab: boolean = false;
  puidSelected: boolean = false;
  isTrainingPlanSliderOpen: boolean = false;
  scopesTreeData: TreeNode[] = [];
  userScopes: SelectedUserScopesDTO | undefined;
  ifUserIsSelected : boolean = false;
  userPUID: string | undefined;
  treeData: TreeNode[] = [];
  userTreeData: TreeNode[] = [];
  userProfile!: UserProfile;
  files: File[] = [];
  alleQMSScope:any[] = [];
  notApplicableText = UserProfileConstants.NotApplicable;
  selectedUser: TreeNode | null = null;
  maxFileSize = MySpaceConstants.Attachment_File_Max_Size;
  userSelected:boolean=false;
  userWithActiveStatusSelected: boolean = false;
  userWithTerminatedStatusSelected: boolean = false;
  userProfileAttachmentMaxLimit= SharedConstants.AttachmentMaxLimit;
  
  @ViewChild(UserProfileSliderComponent) userProfileSlider!:UserProfileSliderComponent;
  userPUIDForEdit:any;
  isUserProfileSliderOpen:boolean = false;

  constructor( private userService: UserService, private eqmsScopeManagementService: EqmsScopeManagementService, private cdr: ChangeDetectorRef){
  }

  loadUsersList() {
    var puid = sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
    this.userService.getUsersForMyEmployeesProfile(puid).subscribe((usersData) => {
      this.userTreeData = this.createEmployeeDetailsTreeNodes(usersData);
    });
  }

  createEmployeeDetailsTreeNodes(employeeDetails: EmployeesDetailsDto[]): TreeNode[] {
    let activeUsersNode: TreeNode = {
      label: DefaultValueConstants.activeUsers_label,
      selectable: false,
      children: [],
    };
  
    let terminatedUsersNode: TreeNode = {
      label: DefaultValueConstants.terminatedUsers_label,
      selectable: false,
      children: [],
    };
  
    employeeDetails.forEach(employee => {
      let nodeLabel = employee.name;
      let formattedDate = this.formatDateToString(employee.terminationDate);
      nodeLabel += formattedDate ? ` (${formattedDate})` : '';
  
      const node: TreeNode = {
        label: nodeLabel,
        style: `color: ${employee.terminationDate != null ? 'red' : 'green'}; font-weight: normal;`
      };
  
      if (employee.terminationDate != null) {
        terminatedUsersNode.children!.push(node);
      } else {
        activeUsersNode.children!.push(node);
      }
    });
  
    return [activeUsersNode, terminatedUsersNode];
  }

  formatDateToString(date: Date | null | undefined): string {
    // Return empty string if date is null or undefined or invalid
    if (!date) return ''; 
    return formatDate(date, 'dd-MMM-yyyy', 'en-US');
  }

  handleTreeSelectChange(event: any) {
    // Checking the selected value has status as active or terminated
    if (event && event.node && event.node.parent.label === DefaultValueConstants.activeUsers_label) {
      this.userWithActiveStatusSelected = true;
      this.userWithTerminatedStatusSelected = false;
    }
    else if(event && event.node && event.node.parent.label === DefaultValueConstants.terminatedUsers_label){
      this.userWithActiveStatusSelected = false; 
      this.userWithTerminatedStatusSelected = true;
    }

   //Get the puid from the input
    if (event && event.node && event.node.label) {
      this.selectedPuid = this.extractPUID(event.node.label);
      this.userPUID = this.selectedPuid;
      this.puidChange(); // to get linked, Ancestor & Decendant Scopes for validation
    }
    else {
      this.selectedPuid = null;
    }
  }

  private extractPUID(node: string) {
    const startIndex = node.indexOf('(') + 1;
    const endIndex = node.indexOf(')', startIndex);
    return node.substring(startIndex, endIndex);
  }

  puidChange(){
    this.myEmployeesTab = true;
    this.puidSelected = this.selectedPuid != null ? true : false;
    if(this.selectedPuid != null){
      this.loadUserProfile();
    }
  }


  async reloadUserData() {
    this.isUserProfileSliderOpen = false;
    this.cdr.detectChanges();
    await this.delay(3000);  // Introducing delay to fetch the latest updated data consistently
    this.loadUserProfile();
  }
  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  

  loadUserProfile(){
    this.userSelected = false;
    this.treeData = [];
    if(this.selectedPuid != null){
      this.userService.getUserByPuid(this.selectedPuid).subscribe((userProfileDetails)=>{
        this.userProfile = userProfileDetails;
        if(this.userProfile.directReporties === null 
          ||this.userProfile.directReporties === undefined 
          || this.userProfile.directReporties?.length === 0){
          this.userProfile.directReporties = [];
          this.userProfile.directReporties.push(this.notApplicableText);
        }
        this.userSelected = true;
          this.loadeQMSScope();
      });
    }
  }
  
loadeQMSScope(){
  this.eqmsScopeManagementService.getEQMSScope().subscribe((eQMSScope) => {
    this.alleQMSScope = eQMSScope;
    //If both primary eQMSScope and selectede QMSScope are null - (in terminated User Condition). no need to construct tree Node for Scopes
    if(this.userProfile.primaryeQMSScopeId !== null || (Array.isArray(this.userProfile.selectedeQMSScopeIds) && this.userProfile.selectedeQMSScopeIds.length > 0)){ 
      this.treeData.push({
        label: eQMSScope.eQMSScopeName,
        icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId) ? UserProfileConstants.PrimaryeQMSScopeIcon : undefined,
        styleClass: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId)
          || this.userProfile.selectedeQMSScopeIds?.some(e => e === eQMSScope.eQMSScopeId)
          ? UserProfileConstants.SelectedeQMSScopeStyleClass
          : UserProfileConstants.UnselectedeQMSScopeStyleClass,

        children: eQMSScope.children
          ? this.updateTreeNodes(eQMSScope.children)
          : undefined,
        expanded: true
      });
    }
  });
}

private updateTreeNodes(nodes: any): TreeData[] {
  let children: TreeNode[] = [];
  nodes.forEach((childNode: any) => {
    // Check if this node or its children should be loaded
    if (this.shouldLoadSiblingNodes(childNode) || (childNode.children && this.shouldLoadChildrenNodes(childNode.children))) {
      children.push({
        label: childNode.eQMSScopeName,
        icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId)
          ? UserProfileConstants.PrimaryeQMSScopeIcon : undefined,
        styleClass: ( this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId)
          || this.userProfile.selectedeQMSScopeIds?.some(e => e === childNode.eQMSScopeId)
          ? UserProfileConstants.SelectedeQMSScopeStyleClass
          : UserProfileConstants.UnselectedeQMSScopeStyleClass,
        children: childNode.children && this.shouldLoadChildrenNodes(childNode.children)
          ? this.updateTreeNodes(childNode.children)
          : undefined,
        expanded: true
      });
    }
  });
  return children;
}

shouldLoadChildrenNodes(nodes: any[]): boolean {
  let shouldLoad = false;

  // Loop through the children and check if any of the data meet the criteria to load
  for (let i = 0; i < nodes.length; i++) {
    const childNode = nodes[i];
    if (( this.userProfile.primaryeQMSScopeId !== null && childNode.eQMSScopeId === this.userProfile.primaryeQMSScopeId)
      || this.userProfile.selectedeQMSScopeIds?.includes(childNode.eQMSScopeId)) {
      shouldLoad = true;
      break;
    } else if (childNode.children !== undefined && childNode.children !== null) {
      // check child nodes recursively
      if (this.shouldLoadChildrenNodes(childNode.children)) {
        shouldLoad = true;
        break;
      }
    }
  }

  return shouldLoad;
}

shouldLoadSiblingNodes(node: any): boolean {
  // check if the node should be loaded
  return (this.userProfile.primaryeQMSScopeId !== null && node.eQMSScopeId === this.userProfile.primaryeQMSScopeId)
    || (this.userProfile.selectedeQMSScopeIds?.includes(node.eQMSScopeId) ?? false);
}
  
  editUserProfile()
  {
    this.isUserProfileSliderOpen = !this.isUserProfileSliderOpen;
    this.userPUIDForEdit = this.selectedPuid;
    this.userProfileSlider.getUserProfileDataForEdit(this.userPUIDForEdit);
  }

  uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
    this.files = [...this.files, ...uploadedFiles];
    uploadedFiles.forEach((file) => {
      const modifiedFile = new File([file], this.selectedPuid! + '/' + file.name, { type: file.type });
      this.userService.uploadFile(modifiedFile,UserProfileConstants.UserProfileAttachmentFolderName).subscribe((response)=>{
        let attachmentDetails = {
              attachmentFileType: response.fileExtension,
              fileId: response.fileId,
              attachmentFilePath: modifiedFile.name,
              attachmentFileName: file.name,
        }
        if(this.selectedPuid != null){
          this.userService.addAttachment(this.selectedPuid, attachmentDetails).subscribe((result)=>{
            //Get attachment details, and reload data on the screen
            this.reloadAttachments();
          })
        }
      })
    });
    const fileNames = uploadedFiles.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  private reloadAttachments(){
    setTimeout(()=>{
      if(this.selectedPuid != null){
        this.userService.getAttachmentsForUser(this.selectedPuid).subscribe((result)=>{
          this.userProfile.attachments = result;
        })
      }
    }, 3000);
  }

}
